var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("pages-wrapper", [
    _c("div", { staticClass: "about-page" }, [
      _c("h1", { staticClass: "about-title" }, [
        _vm._v("\n      " + _vm._s(_vm.pageTitle) + "\n    ")
      ]),
      _c("div", { domProps: { innerHTML: _vm._s(_vm.PAGE_CONTENT) } })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }